<script setup lang="ts">
import { ref } from 'vue'

const props = defineProps<{
  isOpen: boolean
  image: string
  imageAlt: string
  title: string
  description: string
}>()

const emit = defineEmits<{
  close: []
  neverShowAgain: []
  goToRevalidation: []
}>()

const neverShowAgain = ref(false)

function handleClose() {
  if (neverShowAgain.value)
    emit('neverShowAgain')
  emit('close')
}

function handleGoToRevalidation() {
  if (neverShowAgain.value)
    emit('neverShowAgain')
  emit('goToRevalidation')
}

function handleOverlayClick(event: MouseEvent) {
  if (event.target === event.currentTarget)
    handleClose()
}
</script>

<template>
  <Teleport to="body">
    <div v-if="props.isOpen" class="revalidation-welcome-overlay" @click="handleOverlayClick">
      <div class="revalidation-welcome-panel">
        <SharedSmoothImage
          class="revalidation-welcome-image"
          :src="image"
          :alt="imageAlt"
        />

        <div class="revalidation-welcome-content">
          <div class="revalidation-welcome-text-group">
            <h2 class="revalidation-welcome-title text-brand-primary-pure">
              {{ title }}
            </h2>

            <p class="revalidation-welcome-description fonts-body-medium-regular text-neutral-low-medium">
              {{ description }}
            </p>
          </div>

          <SolButton
            id="revalidation-welcome-cta"
            variant="primary"
            size="large"
            class="revalidation-welcome-cta"
            @click="handleGoToRevalidation"
          >
            Fazer revalidação
          </SolButton>

          <SolCheckbox
            id="revalidation-welcome-never-show"
            name="revalidation-welcome-never-show"
            value="never-show"
            label="Não mostrar novamente."
            class="revalidation-welcome-checkbox"
            :checked="neverShowAgain"
            @change="neverShowAgain = !neverShowAgain"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped lang="scss">
.revalidation-welcome-overlay {
  @apply fixed inset-0;
  @apply flex items-center justify-center;
  @apply p-4;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.revalidation-welcome-panel {
  @apply flex flex-col;
  @apply bg-neutral-high-pure;
  width: 100%;
  max-width: 500px;
  border-radius: 16px;
  overflow: hidden;
}

.revalidation-welcome-image {
  @apply w-full block;
  height: 160px;

  @screen md:system {
    height: 188px;
  }
}

.revalidation-welcome-content {
  @apply flex flex-col items-start;
  padding: 24px;
  gap: 24px;

  @screen md:system {
    padding: 32px 40px;
  }
}

.revalidation-welcome-text-group {
  @apply flex flex-col;
  gap: 16px;
}

.revalidation-welcome-title {
  font-family: 'Grotesk', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2;
}

.revalidation-welcome-description {
  @apply text-left;
}

.revalidation-welcome-cta {
  @apply w-full;
}

.revalidation-welcome-checkbox {
  @apply self-center;
}
</style>
